export default "<app-navigation></app-navigation>\n"